import { render, staticRenderFns } from "./TipoDispositivoPantalla.vue?vue&type=template&id=012572f4&"
import script from "./TipoDispositivoPantalla.vue?vue&type=script&lang=ts&"
export * from "./TipoDispositivoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('012572f4', component.options)
    } else {
      api.reload('012572f4', component.options)
    }
    module.hot.accept("./TipoDispositivoPantalla.vue?vue&type=template&id=012572f4&", function () {
      api.rerender('012572f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoDispositivo/TipoDispositivoPantalla.vue"
export default component.exports